// extracted by mini-css-extract-plugin
export default {"loginPage":"LoginPage_loginPage__qcTQn","loginCard":"LoginPage_loginCard__rNTGl","slideUp":"LoginPage_slideUp__nDyJW","submitBtn":"LoginPage_submitBtn__z-r-O"};